import { DateTime } from 'luxon'

import { PlatformDevice } from '@/client/services/platform/constants'
import composeRichText from '@/client/services/richText/composeRichText'
import { get2025CommunitySurveyUrl } from '@/client/services/url'

import { makeBannerDataLoader } from './helpers'

const BANNER_SLUG = 'community-survey-dec-2025'
const BANNER_START_DATE = DateTime.fromObject({ year: 2025, month: 12, day: 8 }).startOf('day')
const BANNER_END_DATE = DateTime.fromObject({ year: 2025, month: 12, day: 14, hour: 11 }).setZone(
  'America/New_York'
)

export default makeBannerDataLoader({
  name: BANNER_SLUG,
  load(context) {
    const now = DateTime.now()
    const surveyUrl = get2025CommunitySurveyUrl()

    if (now < BANNER_START_DATE || now > BANNER_END_DATE) {
      return null
    }

    if (context.user.platformDevice === PlatformDevice.DESKTOP) {
      return {
        slug: BANNER_SLUG,
        content: composeRichText(ctx =>
          ctx.paragraph(
            'Share your feedback in our end-of-year community survey! ',
            ctx.linkExternal(surveyUrl, 'Take The Survey')
          )
        ),
      }
    }

    return {
      slug: BANNER_SLUG,
      content: composeRichText(ctx =>
        ctx.paragraph('Take the ', ctx.linkExternal(surveyUrl, '2025 Community Survey'), '!')
      ),
    }
  },
})
